namespace $ {

	export const $shm_hitalama_map_widget_presets_def_all = {
		entity_editor: {
			type: 'entity_editor',
			title: 'Таблица сущностей',
			icon: 'form_textbox',
		},
		tsx: {
			type: 'tsx',
			title: 'TSX',
			icon: 'code_braces',
		},
		deckgl_example: {
			type: 'deckgl_example',
			title: 'Deck.gl (example)',
			icon: 'map',
		},
		echarts_example: {
			type: 'echarts_example',
			title: 'ECharts',
			icon: 'chart_bar',
		},
		secrets: {
			type: 'secrets',
			title: 'Секреты',
			icon: 'key',
		},
		tg_ext: {
			type: 'tg_ext',
			title: 'Telegram-расширение',
			icon: 'send',
		},
		input: {
			type: 'input',
			title: 'Input',
			icon: 'form_textbox',
		},
		range: {
			type: 'range',
			title: 'Range',
			icon: 'tune_variant',
		},
		date: {
			type: 'date',
			title: 'Date',
			icon: 'calendar',
		},
		select: {
			type: 'select',
			title: 'Select',
			icon: 'form_dropdown',
		},
		button: {
			type: 'button',
			title: 'Button',
			icon: 'gesture_tap_button',
		},
	} as const

	export type $shm_hitalama_map_widget_presets_def_type_name = keyof typeof $shm_hitalama_map_widget_presets_def_all & string

	export type $shm_hitalama_map_widget_presets_def = {
		readonly type: string
		readonly title?: string
		readonly icon?: string
	}

	export const $shm_hitalama_map_widget_presets_def_types = Object.keys(
		$shm_hitalama_map_widget_presets_def_all
	) as $shm_hitalama_map_widget_presets_def_type_name[]

	export type $shm_hitalama_map_widget_presets_item_type =
		| $shm_hitalama_map_widget_def_type_name
		| $shm_hitalama_map_widget_presets_def_type_name

	export function $shm_hitalama_map_widget_presets_def( type: string ): $shm_hitalama_map_widget_presets_def | undefined {
		return $shm_hitalama_map_widget_presets_def_all[ type as $shm_hitalama_map_widget_presets_def_type_name ]
	}

	export function $shm_hitalama_map_widget_presets_def_exists( type: string ): type is $shm_hitalama_map_widget_presets_def_type_name {
		return type in $shm_hitalama_map_widget_presets_def_all
	}

	export const $shm_hitalama_map_widget_presets_def_titles: Record<string, string | undefined> = Object.fromEntries(
		Object.values( $shm_hitalama_map_widget_presets_def_all as Record<string, $shm_hitalama_map_widget_presets_def> )
			.filter( def => def.title !== undefined )
			.map( def => [ def.type, def.title ] )
	)

	export function $shm_hitalama_map_widget_presets_item_title( type: string ) {
		return $shm_hitalama_map_widget_presets_def( type )?.title
			?? $shm_hitalama_map_widget_def( type )?.title
			?? type
	}

	export function $shm_hitalama_map_widget_presets_item_exists( type: string ): type is $shm_hitalama_map_widget_presets_item_type {
		return $shm_hitalama_map_widget_def_exists( type )
			|| $shm_hitalama_map_widget_presets_def_exists( type )
	}

}
